import { isAnyOf } from "@reduxjs/toolkit"

import { createMtListenerMiddleware } from "@/lib/storage/create-mt-listener-middleware"
import { RootState } from "@/lib/storage/redux-store"
import { collectionsApi } from "./api/collections-api"
import { recentItemsApi } from "./api/recent-items-api"
import { savedPlacesApi } from "./api/saved-places-api"
import { tripsApi } from "./api/trips-api"
import { createChat } from "./chat-thunks"

const recentItemsSyncMiddleware = createMtListenerMiddleware<RootState>(
  "recent-items-sync-middleware"
)

recentItemsSyncMiddleware.startListening({
  matcher: isAnyOf(
    createChat.fulfilled,
    tripsApi.endpoints.createTripFromText.matchFulfilled,
    tripsApi.endpoints.updateTrip.matchFulfilled,
    tripsApi.endpoints.deleteTrip.matchFulfilled,
    tripsApi.endpoints.leaveTrip.matchFulfilled,
    collectionsApi.endpoints.updateCollection.matchFulfilled,
    collectionsApi.endpoints.deleteCollection.matchFulfilled,
    savedPlacesApi.endpoints.addSavedPlace.matchFulfilled,
    savedPlacesApi.endpoints.bulkAddSavedPlaces.matchFulfilled
  ),
  effect: (_, listenerApi) => {
    listenerApi.dispatch(recentItemsApi.util.invalidateTags(["RecentItems"]))
  },
})

export { recentItemsSyncMiddleware }
